import { types } from "../../types/types";
const urlBase= process.env.REACT_APP_URL

export const traerUserAutogestion = () => async (
  dispatch
  )=>{
    let body= {
        "dni": "99999999",
        "password": "9aOTKBdW",
        "esUserPublico": true
      }
      fetch(`${urlBase}/api/Authenticate`,{
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json',
        }
    })
    .then(res=>res.json())
    .then(res=>{
      dispatch({
          type: types.loginUserAutoGestion,
          payload: res
      })
    })
  }





